import { useContext } from 'react';
import Header from 'components/Header';
import PageLoader from 'common/PageLoader';
import { PartnersContext } from './context';
import PageContainer from 'common/PageContainer';
import RecordList from './components/RecordList';
import { FILTERS } from 'pages/Customers/constant';
import { GridFilterBar } from './components/GridFilterBar';

const Partner = () => {
  const partnerContext = useContext(PartnersContext);

  if (!partnerContext || !partnerContext.partnersData) {
    return <div>Something went wrong!</div>;
  }

  const {
    partnersData,
    loadMore,
    handleSearchChange,
    handleClearSearch,
    handleRowClick,
  } = partnerContext;
  const { isLoading, status, error, data } = partnersData;

  const totalCount = data.length;
  console.log("PartnersList Rendered", data);
  const renderPartnerList = () => {
    if (isLoading) return <PageLoader />;
    if (error || status !== 200) {
      if (status === 400) return <div>No data found!</div>;
      return <div>Something went wrong!</div>;
    }
    return (
      <RecordList
        data={data}
        loadMore={loadMore}
        handleRowClick={handleRowClick}
      />
    );
  };
  return (
    <PageContainer>
      <Header totalCount={totalCount} heading={'Partners'} />

      <GridFilterBar
        filterCriteria={FILTERS}
        onSearch={handleSearchChange}
        onClearSearch={handleClearSearch}
        // searchText={''}
        searchKeyword=""
        totalCount={0}
        // handleSearch={undefined}
        // handleClearSearch={undefined}
        allData={data}
      />
      {renderPartnerList()}
    </PageContainer>
  );
};

export default Partner;
